module.exports = __webpack_public_path__ + "img/muhammad-umair-TxQSdnp6D_k-unsplash.32f41007.jpg";